/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs */

const en_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategies are managed by Bitwise Asset Management. Glider executes the rebalancing; Bitwise does not hold your assets.`)
};

const de_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Strategien werden von Bitwise Asset Management verwaltet. Glider führt das Rebalancing aus; Bitwise hält Ihre Assets nicht.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As estratégias são gerenciadas pela Bitwise Asset Management. A Glider executa o rebalanceamento; a Bitwise não detém seus ativos.`)
};

const tr_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stratejiler, Bitwise Asset Management tarafından yönetilir. Yeniden dengeleme işlemini Glider gerçekleştirir; Bitwise varlıklarınızı elinde tutmaz.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`策略由 Bitwise Asset Management 管理。再平衡由 Glider 执行；Bitwise 不会持有你的资产。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`策略由 Bitwise Asset Management 管理。重新平衡由 Glider 執行；Bitwise 不會持有你的資產。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략은 Bitwise Asset Management가 운용합니다. 리밸런싱은 Glider가 실행하며, Bitwise는 사용자의 자산을 보관하지 않습니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегиями управляет Bitwise Asset Management. Ребалансировку выполняет Glider; Bitwise не хранит ваши активы.`)
};

const es_419_campaigns_mag7_spacex_fine_print_managed = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las estrategias son gestionadas por Bitwise Asset Management. Glider ejecuta el rebalanceo; Bitwise no custodia tus activos.`)
};

/**
* | output |
* | --- |
* | "Strategies are managed by Bitwise Asset Management. Glider executes the rebalancing; Bitwise does not hold your assets." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_managed = /** @type {((inputs?: Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_ManagedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_managed(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_managed(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_managed(inputs)
});